<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
.topList {
  height: 175px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .topList-div {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:first-child {
        width: 35%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        flex: 1;
        height: 80%;
        border-left: 1px solid rgba(255, 255, 255, 0.404);
        color: white;
        p {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  .topList-div3 {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // text-align: center;
      &:first-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        border-right: 1px solid rgba(255, 255, 255, 0.404);
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
    }
  }
}
.reportDiv {
  width: 100%;
  height: 450px;
  overflow: auto;
  // padding: 20px;
  border: 1px solid #e6e8ef;
  margin-top: 20px;
  border-radius: 7px;
  .reportDiv-List {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .top {
      display: flex;
      div {
        width: 15%;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #8f9bb3;
        &:last-child {
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #4182eb;
          letter-spacing: 1px;
        }
      }
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .list-left {
        width: 20%;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        height: 210px;
        overflow: hidden;
        div:last-child {
          p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 20px 0;
            span:nth-child(1) {
              display: block;
              width: 40%;
            }
            span:nth-child(2) {
              display: block;
              width: 20%;
            }
            span:nth-child(3) {
              display: block;
              width: 20%;
            }
          }
        }
      }
      .list-right {
        width: 60%;
        height: 260px;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        overflow: hidden;
        .registration-trends {
          width: 100%;
          height: 257px;
        }
      }
      .list-right2 {
        width: 20%;
        height: 180px;
        overflow: hidden;
        p {
          display: flex;
          justify-content: space-around;
          align-items: center;
          font-size: 16px;
          height: 16px;
          line-height: 16px;
          margin: 20px 0;
          span:nth-child(1) {
            display: block;
            width: 20%;
          }
          span:nth-child(2) {
            display: block;
            width: 50%;
            display: flex;
            justify-content: flex-end;
            align-content: center;
          }
          span:nth-child(3) {
            display: block;
            width: 17px;
            height: 17px;
            // background: #bb87f3;
            border-radius: 4px;
          }
          &:nth-child(1) {
            span:nth-child(3) {
              background: #bb87f3;
            }
          }
          &:nth-child(2) {
            span:nth-child(3) {
              background: #22c6be;
            }
          }
          &:nth-child(3) {
            span:nth-child(3) {
              background: #1677ff;
            }
          }
          &:nth-child(4) {
            span:nth-child(3) {
              background: #4cd533;
            }
          }
          &:nth-child(5) {
            span:nth-child(3) {
              background: #09c5ff;
            }
          }
        }
      }
    }
    .to-List {
      width: 100%;
      // height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}

.blue {
  background: #4182eb !important;
  color: white !important;
  border: none;
}
.gray {
  background: #e7e7e8 !important;
  border: none;
  color: #9ba5ba;
  // color: white !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title">用户注册报表</div>

      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>{{ custTraceDetailInfo.custTraceDto.statisDate }}</div>
          <div>
            <el-button
              :class="TraceChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleTraceChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!TraceChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleTraceChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户访问 -->
        <div class="reportDiv-List">
          <div class="top">
            <div>用户访问</div>
            <div>
              <span>{{ custTraceDetailInfo.custTraceDto.dpvCountAll| numberToCurrency }}</span>
            </div>
          </div>
          <div class="list">
            <div class="list-left">
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP访问量</span>
                  <span>{{
                    custTraceDetailInfo.custTraceDto.dpvCountZdApp| numberToCurrency
                  }}</span>
                  <span
                    >{{ custTraceDetailInfo.custTraceDto.dpvRatioZdApp|numFilter }}%</span
                  >
                </p>
                <p>
                  <span>桩到家APP访问量</span>
                  <span>{{
                    custTraceDetailInfo.custTraceDto.dpvCountZdjApp| numberToCurrency
                  }}</span>
                  <span
                    >{{
                      custTraceDetailInfo.custTraceDto.dpvRatioZdjApp|numFilter
                    }}%</span
                  >
                </p>
                <p>
                  <span>支付宝小程序访问量</span>
                  <span>{{
                    custTraceDetailInfo.custTraceDto.dpvCountZdAli| numberToCurrency
                  }}</span>
                  <span
                    >{{ custTraceDetailInfo.custTraceDto.dpvRatioZdAli|numFilter }}%</span
                  >
                </p>
                <p>
                  <span>微信小程序访问量</span>
                  <span>{{
                    custTraceDetailInfo.custTraceDto.dpvCountZdWeChat| numberToCurrency
                  }}</span>
                  <span
                    >{{
                      custTraceDetailInfo.custTraceDto.dpvRatioZdWeChat|numFilter
                    }}%</span
                  >
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="RegistrationTrends"></div>
            </div>
            <div class="list-right2">
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange1"
                    v-model="checkbox1"
                  ></el-checkbox
                ></span>
                <span>访问总量</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange2"
                    v-model="checkbox2"
                  ></el-checkbox
                ></span>
                <span>挚达APP访问量</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange3"
                    v-model="checkbox3"
                  ></el-checkbox
                ></span>
                <span>桩到家APP访问量</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange4"
                    v-model="checkbox4"
                  ></el-checkbox
                ></span>
                <span>支付宝小程序访问量</span>
                <span></span>
              </p>
            </div>
          </div>
          <div class="to-List">
            <el-button type="primary" @click="toVisitor">数据列表</el-button>
          </div>
        </div>
      </div>
      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>{{ custRegistDetailInfo.custRegistDto.statisDate }}</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户注册数 -->
        <div class="reportDiv-List">
          <div class="top">
            <div>用户注册数</div>
            <div>
              <span>{{
                custRegistDetailInfo.custRegistDto.registCountAll| numberToCurrency
              }}</span>
            </div>
          </div>
          <div class="list">
            <div class="list-left">
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP注册数</span>
                  <span>{{
                    custRegistDetailInfo.custRegistDto.registCountZdApp| numberToCurrency
                  }}</span>
                  <span
                    >{{
                      custRegistDetailInfo.custRegistDto.registRatioZdApp|numFilter
                    }}%</span
                  >
                </p>
                <p>
                  <span>桩到家APP注册数</span>
                  <span>{{
                    custRegistDetailInfo.custRegistDto.registCountZdjApp| numberToCurrency
                  }}</span>
                  <span
                    >{{
                      custRegistDetailInfo.custRegistDto.registRatioZdjApp|numFilter
                    }}%</span
                  >
                </p>
                <p>
                  <span>支付宝小程序注册数</span>
                  <span>{{
                    custRegistDetailInfo.custRegistDto.registCountZdAli| numberToCurrency
                  }}</span>
                  <span
                    >{{
                      custRegistDetailInfo.custRegistDto.registRatioZdAli|numFilter
                    }}%</span
                  >
                </p>
                <p>
                  <span>微信小程序注册数</span>
                  <span>{{
                    custRegistDetailInfo.custRegistDto.registCountZdWeChat| numberToCurrency
                  }}</span>
                  <span
                    >{{
                      custRegistDetailInfo.custRegistDto.registRatioZdWeChat|numFilter
                    }}%</span
                  >
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="bindingTrend"></div>
            </div>
            <div class="list-right2">
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange5"
                    v-model="checkbox5"
                  ></el-checkbox
                ></span>
                <span>充电桩注册数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange6"
                    v-model="checkbox6"
                  ></el-checkbox
                ></span>
                <span>挚达APP注册数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange7"
                    v-model="checkbox7"
                  ></el-checkbox
                ></span>
                <span>桩到家APP注册数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange8"
                    v-model="checkbox8"
                  ></el-checkbox
                ></span>
                <span>支付宝小程序注册数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange9"
                    v-model="checkbox9"
                  ></el-checkbox
                ></span>
                <span>微信小程序注册数</span>
                <span></span>
              </p>
            </div>
          </div>
          <div class="to-List">
            <el-button type="primary" @click="toRegistration"
              >数据列表</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
// import dateUtil from "../../../utils/dateUtils";
import { EleResize } from "../../../../config/esresize";
import * as echarts from "echarts";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      daysChange: true,
      TraceChange: true,
      checkbox1: true,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: true,
      checkbox6: false,
      checkbox7: false,
      checkbox8: false,
      checkbox9: false,
      // 访问量
      custTraceDetailInfo: {
        custTraceDto: {
          dpvCountAll: 0,
          dpvCountZdAli: 0,
          dpvCountZdApp: 0,
          dpvCountZdWeChat: 0,
          dpvCountZdjApp: 0,
          dpvRatioZdAli: 0,
          dpvRatioZdApp: 0,
          dpvRatioZdWeChat: 0,
          dpvRatioZdjApp: 0,
          statisDate: "",
        },
        custTraceList: [],
      },
      custTraceStatisDate: [],
      custTraceDpvCountAll: [],
      // 注册
      custRegistDetailInfo: {
        custRegistDto: {
          registCountAll: "",
          registCountZdAli: "",
          registCountZdApp: "",
          registCountZdWeChat: "",
          registCountZdjApp: "",
          registRatioZdAli: "",
          registRatioZdApp: "",
          registRatioZdWeChat: "",
          registRatioZdjApp: "",
          statisDate: "",
        },
        custRegistList: [],
      },
      // custRegistListStatisDate: [],
      // custRegistListDpvCountAll: [],
      // 访问日期，总数
      custTraceChartListStatisDate: [],
      custTraceChartListDpvCountAll: [],
      custTraceChartCountZdApp: [],
      custTraceChartCountZdAli: [],
      custTraceChartCountZdWeChat: [],
      custTraceChartCountChangeList: [],
      countColor: "#bb87f3",
      // 注册日期，总数
      custRegistListStatisDate: [],
      custRegistCountAll: [],
      custRegistCountZdApp: [],
      custRegistCountZdjApp: [],
      custRegistCountZdAli: [],
      custRegistCountZdWeChat: [],
      custRegistCountChangeList: [],
      custRegistColor: "#bb87f3",
    };
  },
  methods: {
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      // 获取用户注册趋势
      // this.getRegistrationTrends();
    },
    //选择系统日期时间
    handleDateChange(val) {
      this.daysChange = !this.daysChange;
      // this.checkbox5 = false
      this.getData();
    },
    //选择系统日期时间
    handleTraceChange(val) {
      this.TraceChange = !this.TraceChange;
      // this.checkbox1 = false
      this.getData();
    },
    toVisitor() {
      let _ = this;
      var url = _.$router.resolve({
        name: "visitorList",
        query: { TraceChange: _.TraceChange },
      });
      window.open(url.href, "_blank");
    },
    toRegistration() {
      let _ = this;
      var url = _.$router.resolve({
        name: "registrationList",
        query: { daysChange: _.daysChange },
      });
      window.open(url.href, "_blank");
    },
    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val } });
      window.open(url.href, "_blank");
    },
    getWeek() {
      let time = new Date().getTime();
      let endTime = time - 6 * 24 * 3600 * 1000;
      this.startDate = this.$dayjs(endTime).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(time).format("YYYY-MM-DD");
      console.log(this.startDate); // 开始时间
      console.log(this.endDate); // 结束时间
    },
    getMonth() {
      let time = new Date().getTime();
      let now = new Date(); // 当前日期
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getFullYear(); // 当前年
      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
      this.startDate = this.$dayjs(monthStartDate).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(monthEndDate).format("YYYY-MM-DD");
    },
    getData() {
      let _ = this;
      if (this.daysChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
      };
      _.custRegistListStatisDate = [];
      _.custRegistCountAll = [];
      _.custRegistCountZdApp = [];
      _.custRegistCountZdjApp = [];
      _.custRegistCountZdAli = [];
      _.custRegistCountZdWeChat = [];
      // 注册
      _.$H.post(_, _.$A.operateStatis.custRegistChart, obj).then((res) => {
        _.custRegistDetailInfo = res.data.data;
        _.custRegistDetailInfo.custRegistList.forEach((item) => {
          _.custRegistListStatisDate.push(item.statisDate);
          _.custRegistCountAll.push(item.registCountAll);
          if (_.checkbox5) {
            _.custRegistCountAll.push(item.registCountAll);
          }else{
            _.custRegistCountAll = []
          }
          if (_.checkbox6) {
            _.custRegistCountZdApp.push(item.registCountZdApp);
          }
          if (_.checkbox7) {
            _.custRegistCountZdjApp.push(item.registCountZdjApp);
          }
          if (_.checkbox8) {
            _.custRegistCountZdAli.push(item.registCountZdAli);
          }
          if (_.checkbox9) {
            _.custRegistCountZdWeChat.push(item.registCountZdWeChat);
          }
        });
        // _.checkbox5 = true;
        _.getBindingTrend();
      });
    },
    getTraceData() {
      let _ = this;
      if (this.TraceChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
      };
      _.custTraceStatisDate = [];
      _.custTraceDpvCountAll = [];
      _.custTraceChartCountZdApp= [],
      _.custTraceChartCountZdAli= [],
      _.custTraceChartCountZdWeChat= [],
      // 访问
      _.$H.post(_, _.$A.operateStatis.custTraceChart, obj).then((res) => {
        _.custTraceDetailInfo = res.data.data;

        _.custTraceDetailInfo.custTraceList.forEach((item) => {
          _.custTraceStatisDate.push(item.statisDate);
          _.custTraceDpvCountAll.push(item.dpvCountAll);
          if (_.checkbox1) {
            _.custTraceDpvCountAll.push(item.dpvCountAll);
          }else{
            _.custTraceDpvCountAll = []
          }
          if (_.checkbox2) {
            _.custTraceChartCountZdApp.push(item.dpvCountZdApp);
          }
          if (_.checkbox3) {
            _.custTraceChartCountZdAli.push(item.dpvCountZdAli);
          }
          if (_.checkbox4) {
            _.custTraceChartCountZdWeChat.push(item.dpvCountZdWeChat);
          }
        });
        _.getRegistrationTrends();
      });
    },

    handleCheckboxChange1() {
      let _ = this;
      console.log(_.checkbox1);
      if (_.checkbox1) {
        _.checkbox2 = false
        _.custTraceChartCountZdApp = [];
        _.checkbox3 = false
        _.custTraceChartCountZdAli = [];
        _.checkbox4 = false
        _.custTraceChartCountZdWeChat = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custTraceDpvCountAll = [];
        _.custTraceStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custTraceChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 访问
          _.detailInfo.custTraceChartList.forEach((item) => {
            // 访问
            _.custTraceStatisDate.push(item.statisDate);
            _.custTraceDpvCountAll.push(item.dpvCountAll);
          });
          _.getRegistrationTrends();
        });
      }else{
        _.custTraceDpvCountAll = [];
        _.getRegistrationTrends();
      }
    },
    handleCheckboxChange2() {
      let _ = this;
      if (_.checkbox2) {
        _.checkbox1 = false
        _.custTraceDpvCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custTraceChartCountZdApp = [];
        _.custTraceStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custTraceChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          //
          _.detailInfo.custTraceChartList.forEach((item) => {
            // 挚达App
            _.custTraceStatisDate.push(item.statisDate);
            _.custTraceChartCountZdApp.push(item.dpvCountZdApp);
          });
          _.getRegistrationTrends();
        });
      }else{
        _.custTraceChartCountZdApp = [];
        _.getRegistrationTrends();
      }
    },
    handleCheckboxChange3() {
      let _ = this;
      if (_.checkbox3) {
        _.checkbox1 = false
        _.custTraceDpvCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custTraceChartCountZdAli = [];
        _.custTraceStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custTraceChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          //
          _.detailInfo.custTraceChartList.forEach((item) => {
            // 桩到家App
            _.custTraceStatisDate.push(item.statisDate);
            _.custTraceChartCountZdAli.push(item.dpvCountZdAli);
          
          });
          _.getRegistrationTrends();
        });
      }else{
        _.custTraceChartCountZdAli = [];
        _.getRegistrationTrends();
      }
    },
    handleCheckboxChange4() {
      let _ = this;
      if (_.checkbox4) {
        _.checkbox1 = false
        _.custTraceDpvCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custTraceChartCountZdWeChat = [];
        _.custTraceStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custTraceChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          //
          _.detailInfo.custTraceChartList.forEach((item) => {
            // 支付宝
            _.custTraceStatisDate.push(item.statisDate);
            _.custTraceChartCountZdWeChat.push(item.dpvCountZdWeChat);
          });
          _.getRegistrationTrends();
        });
      }else{
        _.custTraceChartCountZdWeChat = [];
        _.getRegistrationTrends();
      }
    },

    handleCheckboxChange5() {
      let _ = this;
      if (_.checkbox5) {
        _.checkbox6 = false
        _.custRegistCountZdApp = [];
        _.checkbox7 = false
        _.custRegistCountZdjApp = [];
        _.checkbox8 = false
        _.custRegistCountZdAli = [];
        _.checkbox9 = false
        _.custRegistCountZdWeChat = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custRegistCountAll = [];
        _.custRegistListStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custRegistChart, obj).then((res) => {
          _.custRegistDetailInfo = res.data.data;
          _.custRegistDetailInfo.custRegistList.forEach((item) => {
            _.custRegistListStatisDate.push(item.statisDate);
            _.custRegistCountAll.push(item.registCountAll);
          });
          _.getBindingTrend();
        });
      } else {
        _.custRegistCountAll = [];
        _.getBindingTrend();
      }
    },
    handleCheckboxChange6() {
      let _ = this;

      if (_.checkbox6) {
        _.checkbox5 = false
        _.custRegistCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };

        _.custRegistCountZdApp = [];
        _.custRegistListStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custRegistChart, obj).then((res) => {
          _.custRegistDetailInfo = res.data.data;
          _.custRegistDetailInfo.custRegistList.forEach((item) => {
            _.custRegistListStatisDate.push(item.statisDate);
            _.custRegistCountZdApp.push(item.registCountZdApp);
          });
          _.getBindingTrend();
        });
      } else {
        _.custRegistCountZdApp = [];
        _.getBindingTrend();
      }
    },
    handleCheckboxChange7() {
      let _ = this;
      if (_.checkbox7) {
        _.checkbox5 = false
        _.custRegistCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custRegistCountZdjApp = [];
        _.custRegistListStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custRegistChart, obj).then((res) => {
          _.custRegistDetailInfo = res.data.data;
          //
          _.custRegistDetailInfo.custRegistList.forEach((item) => {
            // 挚达App
            _.custRegistListStatisDate.push(item.statisDate);
            _.custRegistCountZdjApp.push(item.registCountZdjApp);
          });
          _.getBindingTrend();
        });
      } else {
        _.custRegistCountZdjApp = [];
        _.getBindingTrend();
      }
    },
    handleCheckboxChange8() {
      let _ = this;
      // _.checkbox3 = !_.checkbox3;
      if (_.checkbox8) {
        _.checkbox5 = false
        _.custRegistCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custRegistCountZdAli = [];
        _.custRegistListStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custRegistChart, obj).then((res) => {
          _.custRegistDetailInfo = res.data.data;
          //
          _.custRegistDetailInfo.custRegistList.forEach((item) => {
            // 桩到家App
            _.custRegistListStatisDate.push(item.statisDate);
            _.custRegistCountZdAli.push(item.registCountZdAli);
          });
          _.getBindingTrend();
        });
      } else {
        _.custRegistCountZdAli = [];
        _.getBindingTrend();
      }
    },
    handleCheckboxChange9() {
      let _ = this;
      // _.checkbox4 = !_.checkbox4;
      if (_.checkbox9) {
        _.checkbox5 = false
        _.custRegistCountAll = [];
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custRegistCountZdWeChat = [];
        _.custRegistListStatisDate = [];
        _.$H.post(_, _.$A.operateStatis.custRegistChart, obj).then((res) => {
          _.custRegistDetailInfo = res.data.data;
          //
          _.custRegistDetailInfo.custRegistList.forEach((item) => {
            // 支付宝
            _.custRegistListStatisDate.push(item.statisDate);
            _.custRegistCountZdWeChat.push(item.registCountZdWeChat);
          });
          _.getBindingTrend();
        });
      } else {
        _.custRegistCountZdWeChat = [];
        _.getBindingTrend();
      }
    },
    // 访问
    getRegistrationTrends() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("RegistrationTrends")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f6eefd", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#dec8f5", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cfabf7", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },

          data: this.custTraceStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.custTraceDpvCountAll,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#bb87f3", //改变折线点的颜色
                lineStyle: {
                  color: "#bb87f3", //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custTraceChartCountZdApp,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#22c6be", //改变折线点的颜色
                lineStyle: {
                  color: "#22c6be", //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custTraceChartCountZdAli,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#1677ff", //改变折线点的颜色
                lineStyle: {
                  color: "#1677ff", //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custTraceChartCountZdWeChat,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#4cd533", //改变折线点的颜色
                lineStyle: {
                  color: "#4cd533", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 注册
    getBindingTrend() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("bindingTrend")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#e0ecff", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#d1e5ff", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#3f8fff", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.custRegistListStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.custRegistCountAll,

            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#bb87f3", //改变折线点的颜色
                lineStyle: {
                  color: "#bb87f3", //改变折线颜色
                },
              },
            },
          },
          //     custRegistCountZdApp: [],
          // custRegistCountZdjApp: [],
          // custRegistCountZdAli: [],
          // custRegistCountZdWeChat: [],
          {
            data: this.custRegistCountZdApp,

            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#22c6be", //改变折线点的颜色
                lineStyle: {
                  color: "#22c6be", //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custRegistCountZdjApp,

            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#1677ff", //改变折线点的颜色
                lineStyle: {
                  color: "#1677ff", //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custRegistCountZdAli,

            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#4cd533", //改变折线点的颜色
                lineStyle: {
                  color: "#4cd533", //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custRegistCountZdWeChat,

            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#09c5ff", //改变折线点的颜色
                lineStyle: {
                  color: "#09c5ff", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },

    // echarts 实例
    drawECharts(dom, option) {
      let myChart = this.$echarts.init(document.getElementById(dom));
      let resizeDiv = document.getElementById(dom);
      resizeDiv.removeAttribute("_echarts_instance_");
      // 绘制图表
      myChart.setOption(option);
      let listener = () => {
        myChart.resize();
      };
      EleResize.on(resizeDiv, listener);
    },
  },
  mounted() {
    this.init();
    this.getData();
    this.getTraceData();
    this.getRegistrationTrends();
    this.getBindingTrend();
  },
};
</script>
